import Form from "../components/contact/Form";

export default function Contact() {
  return (
    <>
   <Form /> 
   </>
  )
}
